import React from 'react';
import { Helmet } from 'react-helmet';

const HowToOrder = () => {
    return (
        <main className='htOrder md:px-custom'>
            <Helmet>
                <title>How To Order - Horizon Market Strategies</title>
                <meta
                    name="description"
                    content="Horizon Market Strategies (HMS), your trusted partner in delivering bespoke market research solutions aimed at equipping businesses with actionable insights."
                />
                <meta property="og:title" content="Home - Horizon Market Strategies" />
                <meta
                    property="og:description"
                    content="Horizon Market Strategies (HMS), your trusted partner in delivering bespoke market research solutions aimed at equipping businesses with actionable insights."
                />
                <meta property="og:site_name" content="Horizon Market Strategies" />
            </Helmet>
            <h1>How to Order?</h1>
            <div className="htOrder__Summary">
                Thank you for your interest in creating or maintaining a relationship with Horizon Market Strategies (HMS). We are excited to guide you through the process of ordering the latest report you need.
            </div>
            <div className="htOrder__SecOne">
                <h3>1. Order Online   </h3>
                <p>If you have a specific report in mind, the easiest way to place your order is through our website. Simply click on the links provided on the report page. Our website features straightforward forms that will allow you to receive your report within hours.
                </p>
            </div>
            <div className="htOrder__SecOne">
                <h3>2. Call Us  </h3>
                <p>We understand that some customers prefer to place orders over the phone. If you have questions or concerns about the transaction or the report itself, feel free to call us at  <a
                    href='tel:+13473542413'
                    className='text-[#0000FF] hover:underline visited:text-[#800080] active:text-[#FF0000]'>
                    +1 (347) 354-2413 (US)
                </a>,{/*  */} <a
                    href='tel:+442037695086'
                    className='text-[#0000FF] hover:underline visited:text-[#800080] active:text-[#FF0000]'>
                        +44 20 3769 5086 (UK)
                    </a>

                </p>
                <p>Our customer service representatives are ready to assist you and guide you through the ordering process. </p>
            </div>
            <div className="htOrder__SecOne">
                <h3>3. Email Us   </h3>
                <p>You can also reach out to us via email. Send your details to  <a href="mailto:inquiry@horizon-markets.com"
                    className='text-[#0000FF] hover:underline visited:text-[#800080] active:text-[#FF0000]'>
                    inquiry@horizon-markets.com
                </a>, and a member of our business development team will respond within 24 hours. You can ask any questions you have about our reports or the ordering process.
                </p>
            </div>
            <div className="htOrder__SecTwo">
                <p>When emailing us, please include the following information: </p>

                <ul className='text-[#01212E] text-[14px] text-left font-[400] mb-[2rem]'>
                    <li>- Your full name </li>
                    <li>- Company name </li>
                    <li>- Job title </li>
                    <li>- Address and contact number </li>
                    <li>- Preferred payment method </li>
                    <li>- Billing and delivery address  </li>
                    <li>- Name of the report you wish to order  </li>
                    <li>- Any specific requirements you may have </li>
                </ul>
            </div>
        </main>
    )
}

export default HowToOrder;